<div class="card" role="region" [attr.aria-label]="cardAriaLabel">
  <div class="card__contents ruler ruler--primary">
    <h2 class="mb-1" class="h4">
      <span [innerHTML]="cardTitle"></span>
    </h2>
    <p class="text-small" [innerHTML]="cardHelp"></p>
    <div class="ruler ruler--primary ruler--thin mb-1"></div>
    <router-outlet name="card-body"></router-outlet>
  </div>
</div>
